<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card">

  <div fxLayout="row" style="">
    <div fxFlex="40">
      <span (click)="returnBack()" style="cursor: pointer; margin-right: 15px;">◀️ Go back</span>

      <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading || !prevNextIds?.prevId" (click)="gotoPrev()">Previous</button>
      <button mat-raised-button color="primary" [disabled]="isLoading || !prevNextIds?.nextId" (click)="gotoNext()">Next</button>


    </div>
    <div fxFlex="40" class="text-center" style="text-align: center;">
      <ng-container *ngIf="account">

      </ng-container>
    </div>






  </div>

</mat-card>



<mat-card class="content-card">
  <div fxLayout="row" style="">
    <div fxFlex="50">
      <h3>White-Listed Sender Account <ng-container *ngIf="account">{{ account.id}}</ng-container> </h3>
    </div>
    <div fxFlex="50" style="text-align: right;">
            <span *ngIf="customer" style="margin-left: 15px; margin-right: 15px;">
                <a routerLink="/customers-overview/{{ customer.id }}">{{ customer.firstName }} {{ customer.lastName }}</a>
            </span>
      <span *ngIf="company" style="margin-left: 15px; margin-right: 15px;">
                <a routerLink="/companies/{{ company.id }}">{{ company.name }}</a>
            </span>
    </div>
  </div>
</mat-card>

<div fxLayout="row" style="">
  <div fxFlex="40">

    <ng-container *ngIf="account">



      <mat-card class="content-card" *ngIf="account.customer">
        <mat-card-header>
          <mat-card-title>
            <h5>Customer</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="company-card">
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer">
            <app-content-row [field]="field" [entity]="account.customer"></app-content-row>
          </div>
        </mat-card-content>
        <mat-card-actions align="end">

        </mat-card-actions>
      </mat-card>


    </ng-container>

  </div>

  <div fxFlex="60">

    <ng-container *ngIf="account">

      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Account</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="company-card">
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsAccount">
            <app-content-row [field]="field" [entity]="account"></app-content-row>
          </div>
        </mat-card-content>
        <mat-card-actions align="end">

        </mat-card-actions>
      </mat-card>

    </ng-container>

  </div>

</div>

